import { createContext } from 'react';

export const defaultUserContext = {
  username: 'guest',
  avatar: null,
};

export const UserContext = createContext( {
} );